import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, Stamp, getPaletteColor } from 'pcln-design-system'
import { EarlyBird, Discount, Timer, DollarCircle } from 'pcln-icons'

export const Label = styled(Stamp)`
  color: ${(props) => props.color || getPaletteColor('alert.base')};
  border: solid ${getPaletteColor('border.base')} 1px;
  background: ${getPaletteColor('background.light')};
  min-height: 20px;
  padding: 0px 4px 0px 4px;
  border-radius: ${(props) => props.theme.borderRadii.md};
  flex-shrink: 0;
`

const LabelText = styled(Text.span)`
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) => props.color || getPaletteColor('alert.base')};
`

const icons = {
  earlyBird: EarlyBird,
  discount: Discount,
  timer: Timer,
  dollarCircle: DollarCircle,
}

const propTypes = {
  /** Text rendered inside the label */
  shortText: PropTypes.string.isRequired,

  /** Key used to map to the pcln-icon */
  icon: PropTypes.string,

  color: PropTypes.string,
}

export const SliceMerchandisingStamp = ({ shortText, icon, color }) => {
  const LabelIcon = icons[icon]
  return (
    <Label color={color}>
      {LabelIcon && <LabelIcon size={'14px'} mr={1} />}
      <LabelText color={color}>{shortText}</LabelText>
    </Label>
  )
}

SliceMerchandisingStamp.propTypes = propTypes
SliceMerchandisingStamp.defaultProps = {
  color: '#F06F20',
}
